import React from 'react';
import '../../styles/style.css';

const VillasInValle = () => (
  <div className="container">
    <div className="Villas_in_valle">
      <h1>Villas in Valle do Lobo & Quinta do Lago</h1>
      <p>
        Discover why we have so many repeat clients! Sunbound Villas specialises in holiday villas in the most
        exclusive resorts in the Algarve, including Vale Do Lobo, Quinta do Lago, Dunas Douradas, and Vilamoura.
        With over 15 years of experience renting villas in The Golden Triangle, our advisors can help you find the
        perfect holiday villa. We hope to welcome you to the sunny Algarve very soon.
      </p>
    </div>
  </div>
);

export default VillasInValle;